'use strict'

module.exports = normalize

function normalize(value) {
  return value.toLowerCase().replace(/\b[:-]\b/g, '')
}



//////////////////
// WEBPACK FOOTER
// ./~/property-information/normalize.js
// module id = 205
// module chunks = 163730310732641